import Vue from 'vue'

export const declin = (number: number | string, words: string[]) => {
  number = Number(number) % 100;
  let ending = words[2];
  if (number >= 11 && number <= 19) {
    ending = words[2];
  } else {
    switch (number % 10) {
      case (1):
        ending = words[0];
        break;
      case (2):
      case (3):
      case (4):
        ending = words[1];
        break;
    }
  }
  return ending;
}
export default {
  install () {
    Vue.prototype.$decl = declin
  }
}

declare module 'vue/types/vue' {
  interface Vue {
    $decl: (number: number | string, words: string[]) => string;
  }
}